export const successToast = (toast: any, message: string, infinite?:boolean) => {
  return toast({
    duration: infinite ? null : 3000,
    isClosable: true,
    position: "bottom-left",
    status: "success",
    title: message,
  });
};

export const errorToast = (toast: any, message: string, infinite?:number) => {
  return toast({
    duration: infinite ? null : 3000,
    isClosable: true,
    position: "bottom-left",
    status: "error",
    title: message,
  });
};

export const infoToast = (toast: any, message: string, infinite?:number) => {
  return toast({
    duration: infinite ? null : 3000,
    isClosable: true,
    position: "bottom-left",
    status: "info",
    title: message,
  });
};
